function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { TextTrackMimeType } from '../../core/player/text-track-mime-type';
import { sdkLogger } from '../../logger';
import { extractIso639LanguageCode, iso639lang2to3letter } from '../../utils/iso639-language-helper';
import { TextRole, adaptDashRole } from '../../core/player/role';
/**
 * Shaka Text Track Manager
 *
 * This base implementation is designed to contain common functionality across different Shaka devices
 */ export var ShakaTextTracksManager = /*#__PURE__*/ function() {
    "use strict";
    function ShakaTextTracksManager(player, config) {
        var _this = this;
        _class_call_check(this, ShakaTextTracksManager);
        _define_property(this, "player", void 0);
        _define_property(this, "config", void 0);
        _define_property(this, "cachedTextTracks", void 0);
        _define_property(this, "getSubtitles", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "normalizeSubtitlesTrack", void 0);
        _define_property(this, "currentPosition", void 0);
        _define_property(this, "selectedSubtitlesTrack", void 0);
        this.player = player;
        this.config = config;
        this.cachedTextTracks = null;
        this.getSubtitles = function() {
            return (_this.cachedTextTracks || []).filter(function(track) {
                return !_this.isForcedTrack(track);
            }).map(_this.normalizeSubtitlesTrack);
        };
        this.logger = sdkLogger.withContext('ShakaTextTracksManager');
        this.normalizeSubtitlesTrack = function(textTrack) {
            var _textTrack_originalLanguage;
            var correctedLanguageCode = _this.config.convertTextTrackLangsTo3Letter ? iso639lang2to3letter((_textTrack_originalLanguage = textTrack.originalLanguage) !== null && _textTrack_originalLanguage !== void 0 ? _textTrack_originalLanguage : '') : textTrack.originalLanguage;
            var _textTrack_originalLanguage1;
            var normalisedTrack = {
                id: "".concat(_this.getTextTrackId(textTrack)),
                name: textTrack.label || correctedLanguageCode,
                language: _this.normalizeSubtitlesTrackLanguage((_textTrack_originalLanguage1 = textTrack.originalLanguage) !== null && _textTrack_originalLanguage1 !== void 0 ? _textTrack_originalLanguage1 : ''),
                languageTag: correctedLanguageCode,
                kind: textTrack.kind
            };
            var mimeTypeKey = Object.keys(TextTrackMimeType).find(function(key) {
                return TextTrackMimeType[key] === textTrack.mimeType;
            });
            if (mimeTypeKey) {
                normalisedTrack.mimeType = TextTrackMimeType[mimeTypeKey];
            }
            return normalisedTrack;
        };
        this.currentPosition = 0;
        this.selectedSubtitlesTrack = null;
    }
    _create_class(ShakaTextTracksManager, [
        {
            key: "destroy",
            value: /**
     * Destroy text manager
     */ function destroy() {
                this.preDestroyHook();
                this.cachedTextTracks = [];
            }
        },
        {
            key: "detectAndSetShakaPreferredLanguage",
            value: /**
     * Based on the preferred languages in playout data, find the most similar language in Shaka's tracks
     * and re-configure shaka to set this as the preferred language
     * @param playoutPreferredLanguages - Array of preferred languages from the playout data
     */ function detectAndSetShakaPreferredLanguage(playoutPreferredLanguages) {
                var preferredTrack;
                var playerSubtitles = this.getSubtitles();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var preferredLanguage = _step.value;
                        preferredTrack = preferredLanguage ? playerSubtitles.find(function(track) {
                            var _track_languageTag;
                            return shaka.util.LanguageUtils.areLanguageCompatible(preferredLanguage, (_track_languageTag = track.languageTag) !== null && _track_languageTag !== void 0 ? _track_languageTag : track.language);
                        }) : undefined;
                        if (preferredTrack !== undefined) return "break";
                    };
                    for(var _iterator = playoutPreferredLanguages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _ret = _loop();
                        if (_ret === "break") break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.logger.verbose("Setting Shaka preferred subtitle language ".concat(preferredTrack === null || preferredTrack === void 0 ? void 0 : preferredTrack.language, " from track ").concat(preferredTrack === null || preferredTrack === void 0 ? void 0 : preferredTrack.id, " in the Shaka configuration."));
                // PBSCVJS-4003
                // This will set 'preferredTextLanguage: undefined' in the scenario preferredSubtitlesLanguages
                // specified an unavailable language
                this.player.configure({
                    preferredTextLanguage: preferredTrack === null || preferredTrack === void 0 ? void 0 : preferredTrack.language
                });
            }
        },
        {
            key: "disableSubtitles",
            value: /**
     * Disable subtitles
     * @param config.hasAlreadyToggledForcedNarrative Defensive flag to prevent recursively toggling forced narrative in some scenarios
     * Defaulted to false
     * @param config.enableForcedTrack If true, will try to enable any detected forced text track after disabling current track
     */ function disableSubtitles() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                    hasAlreadyToggledForcedNarrative: false,
                    enableForcedTrack: true
                }, _ref_hasAlreadyToggledForcedNarrative = _ref.hasAlreadyToggledForcedNarrative, hasAlreadyToggledForcedNarrative = _ref_hasAlreadyToggledForcedNarrative === void 0 ? false : _ref_hasAlreadyToggledForcedNarrative, _ref_enableForcedTrack = _ref.enableForcedTrack, enableForcedTrack = _ref_enableForcedTrack === void 0 ? true : _ref_enableForcedTrack;
                var _this_player;
                this.selectedSubtitlesTrack = null;
                (_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.setTextTrackVisibility(false);
                this.config.clearSubtitles();
                this.config.notifySubtitlesTrackChanged();
                this.postDisableSubtitlesHook();
                if (enableForcedTrack) {
                    this.toggleForcedTextTrack({
                        hasAlreadyToggledForcedNarrative: hasAlreadyToggledForcedNarrative
                    });
                }
            }
        },
        {
            key: "enableSubtitles",
            value: /**
     * Enable subtitles for given track ID
     * @param trackId
     */ function enableSubtitles(trackId) {
                var _this = this;
                var _this_cachedTextTracks;
                var trackToEnable = (_this_cachedTextTracks = this.cachedTextTracks) === null || _this_cachedTextTracks === void 0 ? void 0 : _this_cachedTextTracks.find(function(track) {
                    return "".concat(_this.getTextTrackId(track)) === trackId.toString();
                });
                if (trackToEnable) {
                    // clear out previous cues (avoiding potential overlaps)
                    this.config.clearSubtitles();
                    this.setTextTrack(trackToEnable);
                }
            }
        },
        {
            key: "forceReEnableSelectedTrack",
            value: /**
     * Forcefully disable and then re-enable the current selected track
     *
     * This method is used as a workaround for some scenarios where subtitles are disabled from under our nose.
     * For example, on some devices, subtitles will be disabled after seeking without
     * us knowing about it.
     * @returns
     */ function forceReEnableSelectedTrack() {
                var selectedSubtitlesTrack = this.selectedSubtitlesTrack;
                if (!selectedSubtitlesTrack) {
                    return;
                }
                // No need to enable ForcedTrack since we will do it after if necessary
                this.disableSubtitles({
                    enableForcedTrack: false
                });
                if (this.isForcedTrack(selectedSubtitlesTrack)) {
                    this.setTextTrack(selectedSubtitlesTrack);
                } else {
                    this.enableSubtitles("".concat(this.getTextTrackId(selectedSubtitlesTrack)));
                }
            }
        },
        {
            key: "getActiveTextTrack",
            value: /**
     * Retrieve the currently active text track, according to Shaka Player
     * @returns
     */ function getActiveTextTrack() {
                var _this_player;
                return (_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.getTextTracks().find(function(track) {
                    return track.active;
                });
            }
        },
        {
            key: "getLastSelectedTrack",
            value: /**
     * Get the last text track that was intended to be selected by a user
     * @returns
     */ function getLastSelectedTrack() {
                return this.selectedSubtitlesTrack;
            }
        },
        {
            key: "getTextTrackId",
            value: /**
     * Given a shaka track, get its ID
     * @param track
     * @returns
     */ function getTextTrackId(track) {
                /**
         * This addresses https://gspcloud.atlassian.net/browse/VPTJS-13014
         *
         * Clients are expecting a specific format for the text tracks in multiview
         * streams, namely CC1, CC2, CC3, CC4, which come from the originalTextId
         * field currently in shaka. Longer term we would probably want to have those
         * specific names mapped into the track.name field for multiview streams and
         * clients can use those for their logic, but for the time being, this should
         * provide them with the expected format based on the spec here:
         * https://gspcloud.atlassian.net/wiki/spaces/Playback/pages/69861890/MV-SLE+-+Application+Player+Composite#MVSLEApplication&Player(Composite)-Audio&CaptionIdentification
         *
         */ if (this.config.isMultiview) {
                    var _track_originalTextId;
                    return (_track_originalTextId = track.originalTextId) !== null && _track_originalTextId !== void 0 ? _track_originalTextId : track.id;
                }
                var _track_id;
                return (_track_id = track.id) !== null && _track_id !== void 0 ? _track_id : track.originalTextId;
            }
        },
        {
            key: "handleTextTrackChanged",
            value: /**
     * Handle when a new text track has potentially been selected
     */ function handleTextTrackChanged() {
                var activeTextTrack = this.getActiveTextTrack();
                if (activeTextTrack) {
                    var _this_config;
                    if (!this.isTextTrackVisible()) {
                        var _this_config_textDisplayer, _this_config1;
                        (_this_config1 = this.config) === null || _this_config1 === void 0 ? void 0 : (_this_config_textDisplayer = _this_config1.textDisplayer) === null || _this_config_textDisplayer === void 0 ? void 0 : _this_config_textDisplayer.setTextVisibility(true);
                    }
                    (_this_config = this.config) === null || _this_config === void 0 ? void 0 : _this_config.notifySubtitlesTrackChanged(_object_spread_props(_object_spread({}, this.normalizeSubtitlesTrack(activeTextTrack)), {
                        forced: this.isForcedTrack(activeTextTrack)
                    }));
                    // when the client sends PlayoutData.preferredSubtitlesLanguages, the PEI does not set `selectedSubtitlesTrack`
                    // Safari 15.2 can switch the active text track when the audio track is changed.
                    // setting selectedSubtitlesTrack here so that handleSubtitleTracksChanges() can handle Safari
                    // successfully without switching subtitle tracks when audio tracks are changed
                    this.selectedSubtitlesTrack = activeTextTrack;
                }
            }
        },
        {
            key: "handleTracksChanged",
            value: /**
     * Handle when Shaka's internal list of available text tracks has change
     */ function handleTracksChanged() {
                this.preEmitTracksChangedHook();
                this.config.notifySubtitlesTracksChanged(this.getSubtitles());
            }
        },
        {
            key: "setTextTrack",
            value: /**
     * Enable a specific text track
     * @param track
     */ function setTextTrack(track) {
                var _this_player, _this_player1;
                // Here we look for a track with the same language, added later by the player.
                // This is a workaround for a scenario where the original track is stale and Shaka doesn't tell us about the new one.
                // For more info see: https://github.com/NBCUDTC/core-video-sdk-js/pull/1756
                var mostUpToDateTrack = this.getUpToDateTextTrack(track);
                this.selectedSubtitlesTrack = mostUpToDateTrack;
                (_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.selectTextTrack(mostUpToDateTrack);
                (_this_player1 = this.player) === null || _this_player1 === void 0 ? void 0 : _this_player1.setTextTrackVisibility(true);
                this.postSetTextTrackHook();
            }
        },
        {
            key: "toggleForcedTextTrack",
            value: /**
     * Toggle forced narrative text track
     *
     * Will attempt to find and toggle the forced narrative track matching the currently playing audio language.
     * Note that Shaka will refuse to honor the text track toggling if it has not first fired a tracksChanged event.
     * @param config.hasAlreadyToggledForcedNarrative Defensive guard to prevent recursive calling of this method
     * @returns
     */ function toggleForcedTextTrack() {
                var _this = this;
                var hasAlreadyToggledForcedNarrative = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                    hasAlreadyToggledForcedNarrative: false
                }).hasAlreadyToggledForcedNarrative;
                var _this_player;
                var activeAudioTrack = this.config.getActiveAudioTrack();
                var textTracks = (_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.getTextTracks();
                var activeTextTrack = this.getActiveTextTrack();
                var forcedTextTrack = textTracks === null || textTracks === void 0 ? void 0 : textTracks.find(function(track) {
                    return track.originalLanguage === (activeAudioTrack === null || activeAudioTrack === void 0 ? void 0 : activeAudioTrack.originalLanguage) && _this.isForcedTrack(track);
                });
                var isTextTrackVisible = this.isTextTrackVisible();
                // If we don't have an active audio track
                // Or if all text tracks are marked as active, which is a bug on Safari on first play
                // We wait for the next track changes event
                if (!activeAudioTrack || (textTracks === null || textTracks === void 0 ? void 0 : textTracks.every(function(track) {
                    return track.active;
                }))) {
                    return;
                }
                // If active forced text track doesn't match active audio track, we disable it
                if (isTextTrackVisible && activeTextTrack && this.isForcedTrack(activeTextTrack) && activeAudioTrack.originalLanguage !== activeTextTrack.originalLanguage) {
                    // Defensive logic for a possible infinite loop
                    if (hasAlreadyToggledForcedNarrative) {
                        this.logger.warn('Unexpected - Avoiding disabling subtitles, as this was already attempted!');
                    } else {
                        this.disableSubtitles({
                            hasAlreadyToggledForcedNarrative: true
                        });
                        isTextTrackVisible = false;
                    }
                }
                if (forcedTextTrack && !isTextTrackVisible) {
                    this.config.clearSubtitles();
                    this.setTextTrack(forcedTextTrack);
                }
            }
        },
        {
            key: "updateCachedTextTracks",
            value: /**
     * We need to cache the available text tracks as a bug in Shaka sometimes returns no
     * tracks when we later try and actually set a subtitle track to use.
     * This helper allows us to update the cached tracks at the earliest opportunity.
     */ function updateCachedTextTracks() {
                var _this_player;
                var _this_player_getTextTracks;
                var tracks = (_this_player_getTextTracks = (_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.getTextTracks()) !== null && _this_player_getTextTracks !== void 0 ? _this_player_getTextTracks : null;
                this.preCacheHook(tracks);
                this.cachedTextTracks = tracks;
            }
        },
        {
            key: "updateCurrentPosition",
            value: function updateCurrentPosition(position) {
                this.currentPosition = position;
            }
        },
        {
            key: "hideNonForcedSubtitleTracks",
            value: /**
     * Hide any non-forced-narrative subtitle tracks from the user
     */ function hideNonForcedSubtitleTracks() {}
        },
        {
            key: "isForcedActive",
            value: // Not needed in base implementation
            /**
     * Is the forced narrative track currently active?
     * @returns
     */ function isForcedActive() {
                var activeTrack = this.getActiveTextTrack();
                if (!activeTrack) {
                    return false;
                }
                return this.isForcedTrack(activeTrack);
            }
        },
        {
            key: "isTextTrackVisible",
            value: /**
     * Is the text track visible?
     * @returns
     */ function isTextTrackVisible() {
                return this.player.isTextTrackVisible();
            }
        },
        {
            key: "preCacheHook",
            value: /**
     * Hook to allow manipulation of tracks before they are stored in internal cache
     * @param tracks
     * @returns
     */ function preCacheHook(tracks) {
                return tracks;
            }
        },
        {
            key: "postDisableSubtitlesHook",
            value: /**
     * Hook to allow behavior to execute after subtitles are disabled
     */ function postDisableSubtitlesHook() {}
        },
        {
            key: "postSetTextTrackHook",
            value: /**
     * Hook to allow behavior to execute after a text track is set
     */ function postSetTextTrackHook() {}
        },
        {
            key: "preDestroyHook",
            value: /**
     * Hook to allow behavior to execute before common entities are destroyed
     */ function preDestroyHook() {}
        },
        {
            key: "preEmitTracksChangedHook",
            value: /**
     * Hook to allow behavior to execute before new tracks are emitted
     */ function preEmitTracksChangedHook() {}
        },
        {
            key: "getUpToDateTextTrack",
            value: function getUpToDateTextTrack(selectedTrack) {
                var _this = this;
                var _this_player;
                if (this.isForcedTrack(selectedTrack)) {
                    return selectedTrack;
                }
                var textTracks = (_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.getTextTracks();
                if (!textTracks || !textTracks.length) {
                    return selectedTrack;
                }
                var matchingTracks = textTracks.filter(function(track) {
                    var _track_language, _selectedTrack_language;
                    return !_this.isForcedTrack(track) && ((_track_language = track.language) !== null && _track_language !== void 0 ? _track_language : track.originalLanguage) === ((_selectedTrack_language = selectedTrack.language) !== null && _selectedTrack_language !== void 0 ? _selectedTrack_language : selectedTrack.originalLanguage);
                }).sort(function(trackA, trackB) {
                    return trackB.id - trackA.id;
                });
                var matchingTrack = matchingTracks.find(function(track) {
                    return _this.getTextTrackId(track) === _this.getTextTrackId(selectedTrack);
                });
                if (matchingTrack) {
                    return matchingTrack;
                } else if (matchingTracks.length > 0) {
                    return matchingTracks[0];
                }
                return selectedTrack;
            }
        },
        {
            key: "isForcedTrack",
            value: function isForcedTrack(track) {
                var _track_roles;
                return track.kind === 'forced' || !!((_track_roles = track.roles) === null || _track_roles === void 0 ? void 0 : _track_roles.find(function(role) {
                    return adaptDashRole(role) === TextRole.ForcedSubtitle;
                }));
            }
        },
        {
            key: "normalizeSubtitlesTrackLanguage",
            value: function normalizeSubtitlesTrackLanguage(language) {
                var normalizedLanguageCode = this.config.convertTextTrackLangsTo3Letter ? iso639lang2to3letter(language) : language;
                return extractIso639LanguageCode(normalizedLanguageCode !== null && normalizedLanguageCode !== void 0 ? normalizedLanguageCode : '');
            }
        }
    ]);
    return ShakaTextTracksManager;
}();

//# sourceMappingURL=shaka-text-tracks-manager.js.map